/* Product media — product-page gallery, fullscreen lightbox, ritual band slots.
 *
 * Markup is server-rendered from Shopify product media:
 *   snippets/pdp-gallery.liquid       [data-ddc-gallery] stage + thumbs + dots
 *   snippets/cv-product-media.liquid  [data-gal-set] slot buttons on the homepage
 *                                     and <script type="application/json" data-ddc-media>
 *                                     (the media list the lightbox shows)
 *
 * Nothing heavy loads up front: videos, YouTube/Vimeo iframes and 3D models are
 * created only when a shopper presses play, and removed when they move away.
 *
 * Size switch (sections/pdp-main.liquid) sets #pdp-hero.src to the chosen
 * size's image. A MutationObserver turns that into "go to that media", so the
 * section keeps working unchanged. window.ddcGallery.showMedia(idOrSrc) does
 * the same for any other caller.
 *
 * Loaded from both snippets, possibly several times on one page: once-guard.
 */
(function () {
  'use strict';
  if (window.__ddcGalleryLoaded) return;
  window.__ddcGalleryLoaded = true;

  var d = document, W = window, H = d.documentElement;
  var mq = function (q) { return W.matchMedia ? W.matchMedia(q) : { matches: false }; };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var MAX_ZOOM = 4;

  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function el(tag, cls, attrs) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    for (var k in attrs || {}) n.setAttribute(k, attrs[k]);
    return n;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function now() { return Date.now(); }

  /* "…/files/ddc-product-body-wash.png?v=1&width=1200" -> "ddc-product-body-wash.png".
     Also strips legacy size suffixes (_1200x) so old-style URLs still match. */
  function fileKey(src) {
    if (!src) return '';
    src = String(src).split('#')[0].split('?')[0];
    src = src.slice(src.lastIndexOf('/') + 1).toLowerCase();
    return src.replace(/_(\d+x\d*|x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(@\dx)?(?=\.[a-z0-9]+$)/, '');
  }

  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ---- media lists ------------------------------------------------------ */
  var sets = {};
  function readSet(key) {
    if (!key) return null;
    if (sets[key]) return sets[key];
    var node = null;
    $$('script[data-ddc-media]').some(function (s) {
      if (s.getAttribute('data-ddc-media') === key) { node = s; return true; }
      return false;
    });
    if (!node) return null;
    try { sets[key] = JSON.parse(node.textContent); } catch (e) { return null; }
    return sets[key];
  }
  function indexOfRef(items, ref) {
    if (ref == null || !items) return -1;
    var id = String(ref).replace(/^gid:\/\/shopify\/\w+\//, '');
    var key = fileKey(ref);
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === id) return i;
    }
    for (i = 0; i < items.length; i++) {
      if (key && fileKey(items[i].src) === key) return i;
    }
    return -1;
  }
  function isVideo(item) { return item.type === 'video' || item.type === 'external_video'; }

  /* ---- players (on demand) ---------------------------------------------- */
  function loadModelViewer(box) {
    var S = W.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') return;
    S.loadFeatures([{
      name: 'model-viewer-ui', version: '1.0',
      onLoad: function (err) {
        if (err) return;
        var mv = box.querySelector('model-viewer');
        if (mv && S.ModelViewerUI) { try { new S.ModelViewerUI(mv); } catch (e) {} }
      }
    }]);
  }

  function buildPlayer(item) {
    var box = el('div', 'ddc-gplayer ddc-gplayer--' + item.type);
    if (item.type === 'external_video' && item.extId) {
      var id = encodeURIComponent(item.extId);
      var src = item.host === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1&playsinline=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
      box.appendChild(el('iframe', '', {
        src: src,
        title: item.alt || 'Product video',
        allow: 'autoplay; encrypted-media; picture-in-picture; fullscreen',
        allowfullscreen: '',
        referrerpolicy: 'strict-origin-when-cross-origin'
      }));
    } else if (item.type === 'video' && item.html) {
      box.innerHTML = item.html;
      var v = box.querySelector('video');
      if (v) {
        v.setAttribute('playsinline', '');
        v.controls = true;
        if (item.alt) v.setAttribute('aria-label', item.alt);
        /* Called inside the shopper's click, so sound is allowed. */
        try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
    } else if (item.type === 'model' && item.html) {
      box.innerHTML = item.html;
      loadModelViewer(box);
    }
    return box;
  }
  function stopPlayer(box) {
    if (!box) return;
    var v = box.querySelector('video');
    if (v) { try { v.pause(); } catch (e) {} }
    if (box.parentNode) box.parentNode.removeChild(box);
  }

  /* =======================================================================
     Product-page gallery
     ======================================================================= */
  var galleries = [];

  function Gallery(root) {
    this.root = root;
    this.key = root.getAttribute('data-gallery-key');
    this.track = root.querySelector('.ddc-gal__track');
    this.slides = $$('.ddc-gal__slide', root);
    this.thumbs = $$('.ddc-gal__thumb', root);
    this.dots = $$('.ddc-gal__dot', root);
    this.rail = root.querySelector('.ddc-gal__thumbs');
    this.prevBtn = root.querySelector('[data-gal-prev]');
    this.nextBtn = root.querySelector('[data-gal-next]');
    this.counter = root.querySelector('[data-gal-current]');
    this.live = root.querySelector('[data-gal-live]');
    this.count = this.slides.length;
    this.index = -1;
    this.player = null;
    if (!this.track || !this.count) return;
    this.bind();
    this.setActive(clamp(parseInt(root.getAttribute('data-start'), 10) || 0, 0, this.count - 1), false, true);
    this.snap(true);
    this.watchHero();
    galleries.push(this);
  }

  Gallery.prototype.items = function () { return readSet(this.key) || []; };

  Gallery.prototype.bind = function () {
    var self = this, root = this.root, track = this.track, tick = 0;

    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = setTimeout(function () {
        tick = 0;
        var w = track.clientWidth;
        if (!w) return;
        var i = clamp(Math.round(track.scrollLeft / w), 0, self.count - 1);
        /* A programmatic smooth scroll passes over the slides in between;
           don't make each of them active (and announce it) on the way. */
        if (self.pending != null) {
          if (Math.abs(track.scrollLeft - self.pending * w) < 2) self.pending = null;
          return;
        }
        if (i !== self.index) self.setActive(i, true);
      }, 40);
    }, { passive: true });
    ['pointerdown', 'wheel', 'touchstart'].forEach(function (t) {
      track.addEventListener(t, function () { self.pending = null; }, { passive: true });
    });

    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      var b;
      if ((b = t.closest('[data-gal-prev]'))) return self.go(self.index - 1);
      if ((b = t.closest('[data-gal-next]'))) return self.go(self.index + 1);
      if ((b = t.closest('[data-gal-go]'))) return self.go(parseInt(b.getAttribute('data-gal-go'), 10) || 0);
      if ((b = t.closest('[data-gal-play]'))) return self.play(b.closest('.ddc-gal__slide'));
      if ((b = t.closest('[data-gal-open]'))) {
        var slide = b.closest('.ddc-gal__slide');
        return self.openLightbox(slide ? self.slides.indexOf(slide) : self.index, b);
      }
      if ((b = t.closest('[data-gal-expand]'))) return self.openLightbox(self.index, b);
    });

    root.addEventListener('keydown', function (e) {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
      var k = e.key, to = null;
      if (k === 'ArrowRight' || k === 'Right') to = self.index + 1;
      else if (k === 'ArrowLeft' || k === 'Left') to = self.index - 1;
      else if (k === 'Home') to = 0;
      else if (k === 'End') to = self.count - 1;
      else return;
      e.preventDefault();
      var onThumb = d.activeElement && d.activeElement.classList.contains('ddc-gal__thumb');
      var onDot = d.activeElement && d.activeElement.classList.contains('ddc-gal__dot');
      self.go(to);
      if (onThumb && self.thumbs[self.index]) self.thumbs[self.index].focus({ preventScroll: true });
      if (onDot && self.dots[self.index]) self.dots[self.index].focus({ preventScroll: true });
    });

    /* Hover zoom (mouse only): the image follows the cursor at 2.2x. */
    root.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !FINE.matches || W.innerWidth < 750) return;
      var hit = e.target.closest && e.target.closest('.ddc-gal__hit--zoom');
      if (!hit) return;
      var r = hit.getBoundingClientRect();
      hit.style.setProperty('--zx', clamp((e.clientX - r.left) / r.width * 100, 0, 100) + '%');
      hit.style.setProperty('--zy', clamp((e.clientY - r.top) / r.height * 100, 0, 100) + '%');
      if (!hit.classList.contains('is-zoom')) hit.classList.add('is-zoom');
    });
    root.addEventListener('pointerout', function (e) {
      var hit = e.target.closest && e.target.closest('.ddc-gal__hit--zoom');
      if (hit && !hit.contains(e.relatedTarget)) hit.classList.remove('is-zoom');
    });

    if (W.ResizeObserver) {
      var lastW = track.clientWidth;
      new ResizeObserver(function () {
        if (track.clientWidth !== lastW) { lastW = track.clientWidth; self.snap(true); }
      }).observe(track);
    }
  };

  Gallery.prototype.snap = function (instant) {
    var self = this, left = this.index * this.track.clientWidth;
    this.pending = null;
    if (Math.abs(this.track.scrollLeft - left) < 1) return;
    if (instant || RM.matches || typeof this.track.scrollTo !== 'function') {
      this.track.scrollLeft = left;
      return;
    }
    this.pending = this.index;
    clearTimeout(this.pendingTimer);
    this.pendingTimer = setTimeout(function () { self.pending = null; }, 1200);
    this.track.scrollTo({ left: left, behavior: 'smooth' });
  };

  Gallery.prototype.go = function (i, instant) {
    i = clamp(i, 0, this.count - 1);
    this.setActive(i, true);
    this.snap(instant);
  };

  Gallery.prototype.setActive = function (i, announce, force) {
    if (i === this.index && !force) return;
    this.stop();
    this.index = i;
    var n = this.count;
    this.slides.forEach(function (s, k) {
      var on = k === i;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      if (!on) { var h = s.querySelector('.is-zoom'); if (h) h.classList.remove('is-zoom'); }
    });
    this.thumbs.forEach(function (t, k) {
      if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    this.dots.forEach(function (t, k) {
      if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    if (this.counter) this.counter.textContent = String(i + 1);
    if (this.prevBtn) this.prevBtn.disabled = i === 0;
    if (this.nextBtn) this.nextBtn.disabled = i === n - 1;
    this.revealThumb();
    if (announce && this.live) {
      var s = this.slides[i];
      this.live.textContent = (s.getAttribute('data-label') || '') + ' (' + (i + 1) + ' of ' + n + ')';
    }
    if (announce) {
      try { this.root.dispatchEvent(new CustomEvent('ddc:gallery:change', { bubbles: true, detail: { index: i, mediaId: this.slides[i].getAttribute('data-media-id') } })); } catch (e) {}
    }
  };

  /* Scroll only the rail (never the page) to keep the current thumb visible. */
  Gallery.prototype.revealThumb = function () {
    var rail = this.rail, t = this.thumbs[this.index];
    if (!rail || !t || !rail.offsetParent) return;
    var vertical = rail.scrollHeight > rail.clientHeight + 1 && getComputedStyle(rail).flexDirection === 'column';
    if (vertical) {
      var top = t.offsetTop - rail.offsetTop, h = t.offsetHeight;
      if (top < rail.scrollTop) rail.scrollTop = top - 4;
      else if (top + h > rail.scrollTop + rail.clientHeight) rail.scrollTop = top + h - rail.clientHeight + 4;
    } else if (rail.scrollWidth > rail.clientWidth + 1) {
      var left = t.offsetLeft - rail.offsetLeft, w = t.offsetWidth;
      if (left < rail.scrollLeft) rail.scrollLeft = left - 4;
      else if (left + w > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = left + w - rail.clientWidth + 4;
    }
  };

  Gallery.prototype.play = function (slide) {
    if (!slide) return;
    var i = this.slides.indexOf(slide), item = this.items()[i];
    if (!item) return;
    if (i !== this.index) this.go(i);
    this.stop();
    var box = buildPlayer(item);
    slide.classList.add('is-playing');
    this.root.classList.add('is-playing');
    slide.appendChild(box);
    this.player = box;
    var f = box.querySelector('iframe, video, model-viewer');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  };

  Gallery.prototype.stop = function () {
    if (!this.player) return;
    var slide = this.player.parentNode;
    var hadFocus = slide && slide.contains(d.activeElement);
    stopPlayer(this.player);
    this.player = null;
    this.root.classList.remove('is-playing');
    if (slide) {
      slide.classList.remove('is-playing');
      var btn = slide.querySelector('[data-gal-play]');
      if (hadFocus && btn) btn.focus({ preventScroll: true });
    }
  };

  Gallery.prototype.openLightbox = function (i, opener) {
    var items = this.items(), self = this;
    if (!items.length) return;
    this.stop();
    Lightbox.open(items, i, {
      opener: opener,
      label: this.root.getAttribute('data-gallery-label') || '',
      onChange: function (k) { if (k < self.count) self.go(k, true); },
      focusBack: function () {
        var s = self.slides[self.index];
        return (s && s.querySelector('button')) || self.root.querySelector('[data-gal-expand]');
      }
    });
  };

  Gallery.prototype.show = function (ref) {
    var i = -1, id = String(ref).replace(/^gid:\/\/shopify\/\w+\//, ''), key = fileKey(ref);
    this.slides.forEach(function (s, k) {
      if (i < 0 && s.getAttribute('data-media-id') === id) i = k;
    });
    if (i < 0 && key) {
      this.slides.forEach(function (s, k) {
        if (i < 0 && s.getAttribute('data-key') === key) i = k;
      });
    }
    if (i < 0) return false;
    this.go(i);
    return true;
  };

  /* pdp-main.liquid swaps #pdp-hero.src when a size with its own image is
     picked. Put the hero's own src back (so that slide keeps its picture) and
     move the gallery to the media with that file instead. */
  Gallery.prototype.watchHero = function () {
    var hero = d.getElementById('pdp-hero'), self = this;
    if (!hero || !this.root.contains(hero) || !W.MutationObserver) return;
    var orig = hero.getAttribute('data-orig-src') || hero.getAttribute('src');
    var heroSlide = this.slides.indexOf(hero.closest('.ddc-gal__slide'));
    function handle() {
      var src = hero.getAttribute('src');
      if (!src || src === orig) return;
      var key = fileKey(src), i = -1;
      self.slides.forEach(function (s, k) { if (i < 0 && s.getAttribute('data-key') === key) i = k; });
      if (i > -1) {
        hero.setAttribute('src', orig);
        self.go(i);
      } else {
        /* Not one of the product's media (should not happen): show it in the
           hero slide rather than ignore the shopper's choice. */
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        orig = src;
        self.go(heroSlide < 0 ? 0 : heroSlide);
      }
    }
    new MutationObserver(handle).observe(hero, { attributes: true, attributeFilter: ['src'] });
    handle();
  };

  function initGalleries(scope) {
    $$('[data-ddc-gallery]', scope).forEach(function (r) {
      if (!r._ddcGal) r._ddcGal = new Gallery(r);
    });
  }

  /* =======================================================================
     Lightbox (one per page, appended to <body> so no transformed canvas
     stage can scale or clip it)
     ======================================================================= */
  var Lightbox = (function () {
    var dlg, view, track, countEl, closeBtn, prevBtn, nextBtn, strip, live;
    var items = [], index = 0, opener = null, onChange = null, focusBack = null, slides = [], player = null;
    var zoom = { s: 1, x: 0, y: 0 };
    var lockedY = 0, bodyStyle = null;

    function build() {
      if (dlg) return;
      dlg = el('dialog', 'ddc-glb', { 'aria-modal': 'true', 'aria-label': 'Product media' });
      var startTrap = el('span', 'ddc-glb__trap', { tabindex: '0' });
      var endTrap = el('span', 'ddc-glb__trap', { tabindex: '0' });
      var bar = el('div', 'ddc-glb__bar');
      countEl = el('p', 'ddc-glb__count', { 'aria-hidden': 'true' });
      closeBtn = el('button', 'ddc-glb__btn ddc-glb__close', { type: 'button', 'aria-label': 'Close' });
      closeBtn.innerHTML = ICON.close;
      bar.appendChild(countEl);
      bar.appendChild(closeBtn);
      view = el('div', 'ddc-glb__view');
      track = el('div', 'ddc-glb__track');
      view.appendChild(track);
      prevBtn = el('button', 'ddc-glb__btn ddc-glb__nav ddc-glb__nav--prev', { type: 'button', 'aria-label': 'Previous' });
      nextBtn = el('button', 'ddc-glb__btn ddc-glb__nav ddc-glb__nav--next', { type: 'button', 'aria-label': 'Next' });
      prevBtn.innerHTML = ICON.prev;
      nextBtn.innerHTML = ICON.next;
      strip = el('div', 'ddc-glb__strip');
      live = el('p', 'ddc-visually-hidden', { 'aria-live': 'polite' });

      dlg.appendChild(startTrap);
      dlg.appendChild(bar);
      dlg.appendChild(view);
      dlg.appendChild(prevBtn);
      dlg.appendChild(nextBtn);
      dlg.appendChild(strip);
      dlg.appendChild(live);
      dlg.appendChild(endTrap);
      d.body.appendChild(dlg);

      closeBtn.addEventListener('click', close);
      prevBtn.addEventListener('click', function () { go(index - 1, true); });
      nextBtn.addEventListener('click', function () { go(index + 1, true); });
      strip.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-glb-go]');
        if (b) go(parseInt(b.getAttribute('data-glb-go'), 10) || 0, true);
      });
      view.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-glb-play]');
        if (b) play(b.closest('.ddc-glb__slide'));
      });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      dlg.addEventListener('keydown', onKey);
      startTrap.addEventListener('focus', function () { (lastFocusable() || closeBtn).focus(); });
      endTrap.addEventListener('focus', function () { closeBtn.focus(); });

      /* iOS Safari: stop its own page pinch-zoom while the lightbox is open. */
      ['gesturestart', 'gesturechange'].forEach(function (t) {
        dlg.addEventListener(t, function (e) { e.preventDefault(); });
      });

      bindGestures();
      W.addEventListener('resize', function () {
        if (!isOpen()) return;
        resetZoom(false);
        place(false);
        if (player) fitPlayer(player, items[index]);
      });
    }

    function lastFocusable() {
      var list = $$('button:not([disabled]):not([hidden]), iframe, video[controls]', dlg).filter(function (n) {
        return n.offsetWidth || n.offsetHeight;
      });
      return list[list.length - 1];
    }

    function isOpen() { return !!(dlg && (dlg.open || dlg.hasAttribute('open'))); }

    function lockScroll() {
      var body = d.body;
      lockedY = W.pageYOffset || H.scrollTop || 0;
      var sbw = W.innerWidth - H.clientWidth;
      bodyStyle = body.getAttribute('style');
      /* position:fixed is what actually stops iOS Safari scrolling underneath;
         the scrollbar's width is kept as padding so the canvas does not rescale. */
      body.style.position = 'fixed';
      body.style.top = -lockedY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      if (sbw > 0) body.style.paddingRight = sbw + 'px';
      H.classList.add('ddc-glb-lock');
    }
    function unlockScroll() {
      if (bodyStyle) d.body.setAttribute('style', bodyStyle);
      else d.body.removeAttribute('style');
      H.classList.remove('ddc-glb-lock');
      var prev = H.style.scrollBehavior;
      H.style.scrollBehavior = 'auto';
      W.scrollTo(0, lockedY);
      H.style.scrollBehavior = prev;
    }

    function slideContent(slide, item) {
      if (slide.getAttribute('data-filled')) return;
      slide.setAttribute('data-filled', '1');
      var img = el('img', item.type === 'image' ? 'ddc-glb__img' : 'ddc-glb__poster-img', {
        src: item.src, alt: item.type === 'image' ? (item.alt || '') : '',
        draggable: 'false', decoding: 'async', width: item.w || '', height: item.h || ''
      });
      if (item.srcset) { img.setAttribute('srcset', item.srcset); img.setAttribute('sizes', '100vw'); }
      if (item.type === 'image') {
        slide.appendChild(img);
      } else {
        var b = el('button', 'ddc-glb__poster', {
          type: 'button', 'data-glb-play': '',
          'aria-label': (item.type === 'model' ? 'View in 3D: ' : 'Play video: ') + (item.alt || '')
        });
        b.appendChild(img);
        var badge = el('span', item.type === 'model' ? 'ddc-gal__play ddc-gal__play--3d' : 'ddc-gal__play', { 'aria-hidden': 'true' });
        badge.innerHTML = item.type === 'model' ? '3D' : ICON.play;
        b.appendChild(badge);
        slide.appendChild(b);
      }
    }

    function render() {
      track.innerHTML = '';
      strip.innerHTML = '';
      slides = items.map(function (item, i) {
        var s = el('div', 'ddc-glb__slide', {
          role: 'group', 'aria-roledescription': 'slide',
          'aria-label': (i + 1) + ' of ' + items.length + (item.alt ? ': ' + item.alt : '')
        });
        track.appendChild(s);
        if (items.length > 1) {
          var t = el('button', 'ddc-glb__thumb', {
            type: 'button', 'data-glb-go': String(i),
            'aria-label': 'Show ' + (isVideo(item) ? 'video ' : 'image ') + (i + 1) + ' of ' + items.length
          });
          var ti = el('img', '', { src: item.thumb || item.src, alt: '', loading: 'lazy', draggable: 'false' });
          t.appendChild(ti);
          if (item.type !== 'image') {
            var tb = el('span', 'ddc-glb__tbadge', { 'aria-hidden': 'true' });
            tb.innerHTML = item.type === 'model' ? '3D' : ICON.play;
            t.appendChild(tb);
          }
          strip.appendChild(t);
        }
        return s;
      });
      dlg.classList.toggle('is-single', items.length < 2);
    }

    function place(animate) {
      track.style.transition = animate && !RM.matches ? 'transform .34s cubic-bezier(.2,.8,.2,1)' : 'none';
      track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
    }

    function go(i, animate) {
      if (!items.length) return;
      i = clamp(i, 0, items.length - 1);
      var changed = i !== index;
      stopPlay();
      if (changed) resetZoom(false);
      index = i;
      for (var k = i - 1; k <= i + 1; k++) if (slides[k]) slideContent(slides[k], items[k]);
      slides.forEach(function (s, k) {
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        if (k === i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      place(animate);
      countEl.textContent = (i + 1) + ' / ' + items.length;
      prevBtn.disabled = i === 0;
      nextBtn.disabled = i === items.length - 1;
      $$('.ddc-glb__thumb', strip).forEach(function (t, k) {
        if (k === i) {
          t.setAttribute('aria-current', 'true');
          var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
          if (strip.scrollWidth > strip.clientWidth) strip.scrollLeft = left;
        } else t.removeAttribute('aria-current');
      });
      dlg.classList.toggle('is-media', items[i].type !== 'image');
      live.textContent = (isVideo(items[i]) ? 'Video ' : items[i].type === 'model' ? '3D model ' : 'Image ') + (i + 1) + ' of ' + items.length + (items[i].alt ? ': ' + items[i].alt : '');
      if (changed && onChange) { try { onChange(i); } catch (e) {} }
    }

    function fitPlayer(box, item) {
      var vw = view.clientWidth - 24, vh = view.clientHeight - 8;
      var ar = item.type === 'external_video' ? 16 / 9 : (item.w && item.h ? item.w / item.h : 16 / 9);
      if (item.type === 'model') ar = vw / vh;
      var w = Math.min(vw, vh * ar);
      box.style.width = Math.round(w) + 'px';
      box.style.height = Math.round(w / ar) + 'px';
    }

    function play(slide) {
      var i = slides.indexOf(slide), item = items[i];
      if (!item || item.type === 'image') return;
      if (i !== index) go(i, true);
      stopPlay();
      player = buildPlayer(item);
      fitPlayer(player, item);
      slide.classList.add('is-playing');
      slide.appendChild(player);
      var f = player.querySelector('iframe, video, model-viewer');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }
    function stopPlay() {
      if (!player) return;
      var slide = player.parentNode;
      stopPlayer(player);
      player = null;
      if (slide) slide.classList.remove('is-playing');
    }

    /* ---- zoom ----------------------------------------------------------- */
    function curImg() {
      var s = slides[index];
      return s && items[index] && items[index].type === 'image' ? s.querySelector('.ddc-glb__img') : null;
    }
    function fitted() {
      var s = slides[index], item = items[index];
      var bw = s.clientWidth, bh = s.clientHeight;
      var nw = item.w || bw, nh = item.h || bh, r = Math.min(bw / nw, bh / nh);
      return { bw: bw, bh: bh, fw: nw * r, fh: nh * r };
    }
    function clampPan() {
      var f = fitted();
      var mx = Math.max(0, (f.fw * zoom.s - f.bw) / 2), my = Math.max(0, (f.fh * zoom.s - f.bh) / 2);
      zoom.x = clamp(zoom.x, -mx, mx);
      zoom.y = clamp(zoom.y, -my, my);
    }
    function applyZoom(animate) {
      var img = curImg();
      if (!img) return;
      img.style.transition = animate && !RM.matches ? 'transform .28s cubic-bezier(.2,.8,.2,1)' : 'none';
      img.style.transform = zoom.s > 1.001
        ? 'translate3d(' + zoom.x.toFixed(1) + 'px,' + zoom.y.toFixed(1) + 'px,0) scale(' + zoom.s.toFixed(3) + ')'
        : '';
      dlg.classList.toggle('is-zoomed', zoom.s > 1.001);
    }
    function resetZoom(animate) {
      zoom.s = 1; zoom.x = 0; zoom.y = 0;
      applyZoom(animate);
    }
    /* px, py: point relative to the slide centre that stays under the finger. */
    function zoomTo(ns, px, py, animate) {
      ns = clamp(ns, 1, MAX_ZOOM);
      zoom.x = px - ns * (px - zoom.x) / zoom.s;
      zoom.y = py - ns * (py - zoom.y) / zoom.s;
      zoom.s = ns;
      if (ns <= 1.001) { zoom.x = 0; zoom.y = 0; zoom.s = 1; }
      clampPan();
      applyZoom(animate);
    }
    function rel(cx, cy) {
      var r = slides[index].getBoundingClientRect();
      return { x: cx - (r.left + r.width / 2), y: cy - (r.top + r.height / 2) };
    }
    function onImage(cx, cy) {
      var f = fitted(), p = rel(cx, cy);
      return Math.abs(p.x - zoom.x) <= f.fw * zoom.s / 2 && Math.abs(p.y - zoom.y) <= f.fh * zoom.s / 2;
    }
    function toggleZoomAt(cx, cy) {
      if (!curImg()) return;
      var p = rel(cx, cy);
      if (zoom.s > 1.001) resetZoom(true);
      else zoomTo(2.5, p.x, p.y, true);
    }

    /* ---- gestures --------------------------------------------------------
       One pointer: swipe between items (or pan when zoomed, or drag down to
       close). Two pointers: pinch. Tap: mouse click zooms; touch double-tap
       zooms; a tap off the picture closes. */
    function bindGestures() {
      var ptrs = {}, g = null, lastTap = null, tapTimer = 0;
      function list() { return Object.keys(ptrs).map(function (k) { return ptrs[k]; }); }
      function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }
      function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }

      function startPinch() {
        var p = list();
        if (p.length < 2 || !curImg()) return;
        var m = mid(p[0], p[1]), r = rel(m.x, m.y);
        g = { mode: 'pinch', d0: dist(p[0], p[1]) || 1, s0: zoom.s, x0: zoom.x, y0: zoom.y, m0: r };
        Object.keys(ptrs).forEach(function (id) { try { view.setPointerCapture(+id); } catch (e) {} });
      }

      view.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('.ddc-gplayer')) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        var n = Object.keys(ptrs).length;
        if (n === 1) {
          g = { mode: 'pending', id: e.pointerId, sx: e.clientX, sy: e.clientY, t: now(), zx: zoom.x, zy: zoom.y, type: e.pointerType, target: e.target };
        } else if (n === 2) {
          clearTimeout(tapTimer);
          place(false);
          startPinch();
        }
      });

      view.addEventListener('pointermove', function (e) {
        if (!ptrs[e.pointerId] || !g) return;
        ptrs[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (g.mode === 'pinch') {
          var p = list();
          if (p.length < 2) return;
          var m = mid(p[0], p[1]), r = rel(m.x, m.y);
          var ns = clamp(g.s0 * dist(p[0], p[1]) / g.d0, 1, MAX_ZOOM);
          zoom.s = ns;
          zoom.x = r.x - ns * (g.m0.x - g.x0) / g.s0;
          zoom.y = r.y - ns * (g.m0.y - g.y0) / g.s0;
          clampPan();
          applyZoom(false);
          return;
        }
        if (e.pointerId !== g.id) return;
        var dx = e.clientX - g.sx, dy = e.clientY - g.sy;
        if (g.mode === 'pending') {
          if (Math.hypot(dx, dy) < 8) return;
          try { view.setPointerCapture(e.pointerId); } catch (x) {}
          clearTimeout(tapTimer);
          if (zoom.s > 1.001) g.mode = 'pan';
          else if (Math.abs(dx) >= Math.abs(dy) && items.length > 1) g.mode = 'swipe';
          else if (dy > 0) g.mode = 'down';
          else g.mode = 'none';
        }
        if (g.mode === 'pan') {
          zoom.x = g.zx + dx; zoom.y = g.zy + dy;
          clampPan();
          applyZoom(false);
        } else if (g.mode === 'swipe') {
          var atEdge = (index === 0 && dx > 0) || (index === items.length - 1 && dx < 0);
          track.style.transition = 'none';
          track.style.transform = 'translate3d(calc(' + (-index * 100) + '% + ' + (atEdge ? dx / 3 : dx).toFixed(1) + 'px),0,0)';
        } else if (g.mode === 'down') {
          var s = slides[index];
          s.style.transition = 'none';
          s.style.transform = 'translate3d(0,' + Math.max(0, dy).toFixed(1) + 'px,0)';
          dlg.style.setProperty('--glb-fade', String(clamp(1 - dy / 500, 0.4, 1)));
        }
      });

      function end(e) {
        if (!ptrs[e.pointerId]) return;
        delete ptrs[e.pointerId];
        if (!g) return;
        var left = list();
        if (g.mode === 'pinch') {
          if (zoom.s < 1.02) resetZoom(true);
          if (left.length === 1) {
            var id = Object.keys(ptrs)[0];
            g = { mode: 'pan', id: +id, sx: left[0].x, sy: left[0].y, zx: zoom.x, zy: zoom.y };
          } else if (!left.length) g = null;
          return;
        }
        if (e.pointerId !== g.id) return;
        var dx = e.clientX - g.sx, dy = e.clientY - g.sy, dt = Math.max(1, now() - g.t);
        var mode = g.mode, type = g.type, target = g.target;
        g = null;
        if (e.type === 'pointercancel') { place(true); return; }
        if (mode === 'swipe') {
          var w = view.clientWidth, v = dx / dt;
          if ((dx < -w * 0.15 || v < -0.45) && index < items.length - 1) go(index + 1, true);
          else if ((dx > w * 0.15 || v > 0.45) && index > 0) go(index - 1, true);
          else place(true);
        } else if (mode === 'down') {
          var s = slides[index];
          dlg.style.removeProperty('--glb-fade');
          s.style.transition = 'transform .25s ease';
          s.style.transform = '';
          if (dy > 110) close();
        } else if (mode === 'pending') {
          if (target && target.closest && target.closest('[data-glb-play]')) return; /* its click plays */
          var x = e.clientX, y = e.clientY;
          if (type === 'mouse') {
            if (curImg() && (zoom.s > 1.001 || onImage(x, y))) toggleZoomAt(x, y);
            else close();
            return;
          }
          var t = now();
          if (lastTap && t - lastTap.t < 320 && Math.hypot(x - lastTap.x, y - lastTap.y) < 40) {
            clearTimeout(tapTimer);
            lastTap = null;
            toggleZoomAt(x, y);
          } else {
            lastTap = { t: t, x: x, y: y };
            var off = !(curImg() && (zoom.s > 1.001 || onImage(x, y))) && !(target.closest && target.closest('.ddc-glb__poster'));
            if (off) tapTimer = setTimeout(close, 330);
          }
        }
      }
      view.addEventListener('pointerup', end);
      view.addEventListener('pointercancel', end);
      view.addEventListener('lostpointercapture', function (e) { if (ptrs[e.pointerId] && e.type) end({ pointerId: e.pointerId, clientX: ptrs[e.pointerId].x, clientY: ptrs[e.pointerId].y, type: 'pointerup' }); });

      var lastWheel = 0;
      view.addEventListener('wheel', function (e) {
        if (!isOpen() || (e.target.closest && e.target.closest('.ddc-gplayer'))) return;
        e.preventDefault();
        if (e.ctrlKey && curImg()) {
          var p = rel(e.clientX, e.clientY);
          zoomTo(zoom.s * Math.exp(-e.deltaY * 0.01), p.x, p.y, false);
        } else if (zoom.s > 1.001) {
          zoom.x -= e.deltaX; zoom.y -= e.deltaY;
          clampPan();
          applyZoom(false);
        } else if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 12 && now() - lastWheel > 450) {
          lastWheel = now();
          go(index + (e.deltaX > 0 ? 1 : -1), true);
        }
      }, { passive: false });
    }

    function onKey(e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var k = e.key;
      if (k === 'Escape' || k === 'Esc') { e.preventDefault(); close(); return; }
      if (k === 'ArrowRight' || k === 'Right') { e.preventDefault(); go(index + 1, true); }
      else if (k === 'ArrowLeft' || k === 'Left') { e.preventDefault(); go(index - 1, true); }
      else if (k === 'Home') { e.preventDefault(); go(0, true); }
      else if (k === 'End') { e.preventDefault(); go(items.length - 1, true); }
      else if ((k === '+' || k === '=') && curImg()) { e.preventDefault(); zoomTo(zoom.s * 1.5, 0, 0, true); }
      else if (k === '-' && curImg()) { e.preventDefault(); zoomTo(zoom.s / 1.5, 0, 0, true); }
      else if (k === '0' && curImg()) { e.preventDefault(); resetZoom(true); }
    }

    function open(list, i, opts) {
      if (!list || !list.length) return;
      opts = opts || {};
      build();
      if (isOpen()) close(true);
      items = list;
      onChange = opts.onChange || null;
      focusBack = opts.focusBack || null;
      opener = opts.opener || d.activeElement;
      dlg.setAttribute('aria-label', (opts.label ? opts.label + ' — ' : '') + 'media gallery');
      render();
      index = -1;
      lockScroll();
      if (typeof dlg.showModal === 'function') {
        try { dlg.showModal(); } catch (err) { dlg.setAttribute('open', ''); }
      } else {
        dlg.setAttribute('open', '');
      }
      var cb = onChange;
      onChange = null;
      go(clamp(i || 0, 0, items.length - 1), false);
      onChange = cb;
      closeBtn.focus();
    }

    function close(silent) {
      if (!isOpen()) return;
      stopPlay();
      resetZoom(false);
      if (typeof dlg.close === 'function' && dlg.open) dlg.close();
      dlg.removeAttribute('open');
      dlg.style.removeProperty('--glb-fade');
      unlockScroll();
      track.innerHTML = '';
      strip.innerHTML = '';
      slides = [];
      var target = opener;
      /* The opener may now sit in a slide the gallery made inert (the
         shopper moved on inside the lightbox); ask the owner where to go. */
      if (target && target.closest && target.closest('[inert]') && focusBack) target = focusBack() || null;
      if (silent !== true && target && d.contains(target)) {
        try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
      }
      opener = null;
      onChange = null;
      focusBack = null;
    }

    return { open: open, close: close, isOpen: isOpen, go: function (i) { go(i, true); }, index: function () { return index; } };
  })();

  /* =======================================================================
     Ritual band slots (homepage) and any other [data-gal-set] trigger
     ======================================================================= */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gal-set]');
    if (!b) return;
    var items = readSet(b.getAttribute('data-gal-set'));
    if (!items || !items.length) return;
    e.preventDefault();
    var i = indexOfRef(items, b.getAttribute('data-gal-media'));
    Lightbox.open(items, i < 0 ? 0 : i, { opener: b, label: b.getAttribute('data-gal-label') || '' });
  });

  d.addEventListener('shopify:section:load', function (e) {
    sets = {};
    initGalleries(e.target);
  });
  d.addEventListener('shopify:section:unload', function () { Lightbox.close(true); });

  W.ddcGallery = {
    /* Move the product-page gallery to a media id (numeric or gid) or any URL
       of one of its files. Returns true when found. */
    showMedia: function (ref) {
      for (var i = 0; i < galleries.length; i++) {
        if (d.contains(galleries[i].root) && galleries[i].show(ref)) return true;
      }
      return false;
    },
    /* Open the lightbox on a media list key (data-ddc-media) or an array. */
    open: function (keyOrItems, ref) {
      var items = typeof keyOrItems === 'string' ? readSet(keyOrItems) : keyOrItems;
      if (!items || !items.length) return false;
      var i = typeof ref === 'number' ? ref : indexOfRef(items, ref);
      Lightbox.open(items, i < 0 ? 0 : i, {});
      return true;
    },
    close: function () { Lightbox.close(); },
    galleries: galleries
  };

  initGalleries();
})();
